export enum IRoles {
  'Owner' = 'OWNER',
  'Reader' = 'READER',
}

export interface Roles {
  [uid: string]: IRoles | undefined;
  public?: IRoles;
}
